import React from 'react';
import PropTypes from 'prop-types';
import { transactionPropTypes } from 'common/propTypes';
import { getUserFromRuns } from 'common/api/stockwiz';
import { ordersToCsv } from './orderCsvConversion';
import _ from 'lodash';
import ApplicationDomainUtility from 'v3/common/utils/applicationDomain';

const propTypes = {
  runName: PropTypes.string.isRequired,
  runId: PropTypes.number.isRequired,
  transactions: PropTypes.arrayOf(transactionPropTypes).isRequired,
};
const defaultProps = {};

const TransactionsDownload = ({ runName, runId, transactions }) => {
  const {isUserSignedIn, isStockWiz} = ApplicationDomainUtility;
  const domainAdminUserIds = _.get(
    window,
    'applicationDomain.config.domain_admin_user_ids',
    []
  );
  
  const isDomainAdminUser = domainAdminUserIds.includes(Number(_.get(window, 'currentUserId', '')));
  const isCustomFileNameEnabled = isUserSignedIn && isStockWiz && isDomainAdminUser;

  const handleTransactionsDownload = async () => {
    let customFileName = null;

    if (isCustomFileNameEnabled) {
      const { success, data } = await getUserFromRuns(runId) || {};
      if (success && data) {
        const { broker_client_id, phone_number } = data;
        customFileName = `${runName}-${broker_client_id}-${phone_number}.csv`;
      }
    }

    ordersToCsv(transactions, runName, runId, customFileName);
  };
  
  return (
    <div>
      <button
        className="btn btn-primary btn-sm track"
        type="button"
        data-track-category="Transaction CSV"
        data-track-action="download"
        data-track-label="Transaction CSV"
        onClick={handleTransactionsDownload}
      >
        Download CSV
      </button>
    </div>
  );
};

TransactionsDownload.propTypes = propTypes;
TransactionsDownload.defaultProps = defaultProps;

export default TransactionsDownload;
